import { render, staticRenderFns } from "./SampleSetTest.vue?vue&type=template&id=40540f88&scoped=true"
import script from "./SampleSetTest.vue?vue&type=script&lang=js"
export * from "./SampleSetTest.vue?vue&type=script&lang=js"
import style0 from "./SampleSetTest.vue?vue&type=style&index=0&id=40540f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40540f88",
  null
  
)

export default component.exports